<script>
  export let label;
  export let time;
  let readMore = false;
  export let maxLength = 100;
  let btnMore;
  export let isPurpose = false;
  import { Popover } from 'bootstrap';
  import { onMount } from 'svelte';
  export let onSticky = () => {};
  export let showSticky = false;
  let btnSticky, btnSticky1;
  onMount(() => {
    if (btnMore) {
      new Popover(btnMore, {
        container: btnMore.parentElement,
        animation: false,
      });
    }
    if (showSticky && btnSticky) {
      new Popover(btnSticky, {
        container: btnSticky.parentElement,
        animation: false,
      });
    }
    if (showSticky && btnSticky1) {
      new Popover(btnSticky1, {
        container: btnSticky1.parentElement,
        animation: false,
      });
    }
  });
</script>

{#if isPurpose}
  {#if label.length > maxLength}
    <button
      class="border-0 bg-transparent p-0"
      style="text-align:left;"
      bind:this={btnMore}
      data-bs-placement="top"
      data-bs-toggle="popover"
      data-bs-trigger="hover focus"
      data-bs-content={label}
    >
      <span class="text-break d-block me-1"
        >{label.substr(0, maxLength)}

        ...
      </span>
    </button>
  {:else}
    <span class="text-break d-block me-1">{@html label}</span>
  {/if}
{:else}
  <div class="w-100">
    <div class="d-flex flex-row justify-content-between">
      {#if label.length > maxLength && readMore == false}
        <div class="">
          <div class="d-flex flex-row">
            <span class="text-break d-block me-1"
              >{label.substr(0, maxLength)}
              {#if showSticky}
                <button
                  bind:this={btnSticky}
                  on:click={() => onSticky()}
                  data-bs-placement="top"
                  data-bs-toggle="popover"
                  data-bs-trigger="hover focus"
                  data-bs-content="Click to make it un-sticky"
                  class="color-blue font-weight-400 border-0 mb-0 bg-transparent font-weight-400 py-0"
                  ><img
                    alt=""
                    class="icon-16 me-1"
                    src="/images/sticky-tag.svg"
                  /> Sticky</button
                >
              {/if}
            </span>
          </div>
          <button
            class="border-0 bg-transparent p-0"
            on:click={() => (readMore = true)}
          >
            <span class="color-blue">Read More...</span><br />
          </button>
        </div>
        {#if time != undefined}
          <div class="d-flex flex-row text-nowrap">
            <small class="text-muted"
              ><img
                alt=""
                class="me-1 icon-14"
                src="/images/clock.svg"
              />
              <span>{time}</span></small
            >
          </div>
        {/if}
      {:else}
        <div class="d-flex flex-row">
          <span class="text-break d-block me-1"
            >{@html label}
            {#if showSticky}
              <button
                bind:this={btnSticky1}
                data-bs-placement="top"
                data-bs-toggle="popover"
                data-bs-trigger="hover focus"
                data-bs-content="Click to make it un-sticky"
                on:click={() => onSticky()}
                class="color-blue font-weight-400 border-0 mb-0 bg-transparent font-weight-400 py-0"
                ><img
                  alt=""
                  class="icon-16 me-1"
                  src="/images/sticky-tag.svg"
                /> Sticky</button
              >
            {/if}
          </span>
        </div>

        {#if time != undefined}
          <div class="d-flex flex-row text-nowrap">
            <small class="text-muted"
              ><img
                alt=""
                class="me-1 icon-14"
                src="/images/clock.svg"
              />
              <span>{time}</span></small
            >
          </div>
        {/if}
      {/if}
    </div>
  </div>
{/if}
